"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var scenario_state_1 = require("../../redux/scenario/scenario.state");

var editable_text_scenario_node_container_1 = __importDefault(require("../editable-text-scenario-node/editable-text-scenario-node.container"));

var editable_image_scenario_node_component_1 = __importDefault(require("../editable-image-scenario-node/editable-image-scenario-node.component"));

var editable_image_explanation_scenario_node_component_1 = __importDefault(require("../editable-image-explanation-scenario-node/editable-image-explanation-scenario-node.component"));

var editable_greeting_scenario_node_container_1 = __importDefault(require("../editable-greeting-scenario-node/editable-greeting-scenario-node.container"));

var current_node_view_styles_1 = require("./current-node-view.styles");

var action_row_component_1 = __importDefault(require("../action-row/action-row.component"));

var TextFields_1 = __importDefault(require("@material-ui/icons/TextFields"));

var Image_1 = __importDefault(require("@material-ui/icons/Image"));

var AddPhotoAlternate_1 = __importDefault(require("@material-ui/icons/AddPhotoAlternate"));

var remove_current_node_button_container_1 = __importDefault(require("../remove-current-node-button/remove-current-node-button.container"));

var selectTitle = function selectTitle(nodeType) {
  switch (nodeType) {
    case scenario_state_1.ScenarioNodeType.Greeting:
      return react_1.default.createElement(action_row_component_1.default, {
        Icon: TextFields_1.default,
        text: "\u6328\u62F6\u3075\u304D\u3060\u3057"
      });

    case scenario_state_1.ScenarioNodeType.Text:
      return react_1.default.createElement(action_row_component_1.default, {
        Icon: TextFields_1.default,
        text: "\u30C6\u30AD\u30B9\u30C8\u3075\u304D\u3060\u3057"
      });

    case scenario_state_1.ScenarioNodeType.Image:
      return react_1.default.createElement(action_row_component_1.default, {
        Icon: Image_1.default,
        text: "\u753B\u50CF\u3075\u304D\u3060\u3057"
      });

    case scenario_state_1.ScenarioNodeType.ImageExplanation:
      return react_1.default.createElement(action_row_component_1.default, {
        Icon: AddPhotoAlternate_1.default,
        text: "\u753B\u50CF\u8AAC\u660E\u3075\u304D\u3060\u3057"
      });

    default:
      throw new Error("Invalid nodeType is given !!! nodeType >>> ".concat(nodeType));
  }
};

var selectEditableNodeView = function selectEditableNodeView(id, node) {
  switch (node.type) {
    case scenario_state_1.ScenarioNodeType.Greeting:
      return react_1.default.createElement(editable_greeting_scenario_node_container_1.default, null);

    case scenario_state_1.ScenarioNodeType.Text:
      return react_1.default.createElement(editable_text_scenario_node_container_1.default, {
        nodeId: id,
        node: node
      });

    case scenario_state_1.ScenarioNodeType.Image:
      return react_1.default.createElement(editable_image_scenario_node_component_1.default, {
        nodeId: id,
        node: node
      });

    case scenario_state_1.ScenarioNodeType.ImageExplanation:
      return react_1.default.createElement(editable_image_explanation_scenario_node_component_1.default, {
        nodeId: id,
        node: node
      });

    default:
      return react_1.default.createElement("p", null, "\u8A72\u5F53\u3059\u308B\u5439\u304D\u51FA\u3057\u304C\u5B58\u5728\u3057\u307E\u305B\u3093");
    //TODO show error message
  }
};

var UNREMOVABLE_NODE_IDS = [scenario_state_1.GREETING_SCENARIO_NODE_ID];

var isRemovableNode = function isRemovableNode(nodeId) {
  return !UNREMOVABLE_NODE_IDS.includes(nodeId);
};

var CurrentNodeView = function CurrentNodeView(_ref) {
  var nodeId = _ref.nodeId,
      node = _ref.node;
  return react_1.default.createElement(current_node_view_styles_1.StyledCurrentNodeViewWrapperDiv, {
    "data-meta": "current-node-view"
  }, react_1.default.createElement(current_node_view_styles_1.StyledCurrentNodeTopDiv, null, react_1.default.createElement(current_node_view_styles_1.StyledCurrentNodeTitleDiv, null, selectTitle(node.type)), isRemovableNode(nodeId) && react_1.default.createElement(remove_current_node_button_container_1.default, {
    size: "large"
  })), react_1.default.createElement(current_node_view_styles_1.StyledCurrentNodeDiv, null, react_1.default.createElement(current_node_view_styles_1.StyledCurrentNodeScrollViewDiv, null, selectEditableNodeView(nodeId, node))));
};

exports.default = CurrentNodeView;